export default "__VITE_ASSET__134405a6__"